module.exports = __webpack_public_path__ + "assets/img/4.9ffd7d74.jpg";